import { proxy, useSnapshot } from "valtio";
import { useLocalStorage } from "react-use";
import { useEffect } from "react";

export const debugModeState = proxy({
  isEnabled: false,
});

export function useDebugMode(): [boolean, (isEnabled: boolean) => void] {
  const snapshot = useSnapshot(debugModeState);
  const [storedDebugModeEnabled, setStoredDebugModeEnabled] = useLocalStorage(
    "flo_debug",
    false
  );

  useEffect(() => {
    debugModeState.isEnabled = storedDebugModeEnabled;
  }, [storedDebugModeEnabled]);

  return [
    snapshot.isEnabled && process?.env?.NEXT_PUBLIC_DEBUG === "1",
    (isEnabled: boolean) => {
      if (process?.env?.NODE_ENV !== "production") {
        setStoredDebugModeEnabled(isEnabled);
      }
    },
  ];
}
